import { useEffect, useState } from "react";
import { GET_COUNTY_CITIES } from "../api/constants";

const useCities = () => {
  const [cities, setCities] = useState([]);
    const [cities_detailed, setCitiesDetailed] = useState([]);
  

  useEffect(() => {
    const fetchCities = async () => {
      try {
        const response = await fetch(`${GET_COUNTY_CITIES}/all`);
        const data = await response.json();

        // ✅ tolerate different API shapes
       
        if (Array.isArray(data?.data.citiesList)) {
          setCities(data.data.citiesList);
          setCitiesDetailed(data.data.cities);
        }  else {
          setCities([]);
        }
      } catch (err) {
        console.error("Error fetching cities:");
      } 
    };

    fetchCities();
  }, []);

  return { cities,cities_detailed };
};


export default useCities;
